import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {Icon} from '@techsee/techsee-ui-common/lib/icons/simple-icon';
import {IWifiAnalyzerResults} from '../../../services/AngularServices/WifiAnalyzerService';
import {observer} from 'mobx-react';

interface NetworkTabProps {
    results: IWifiAnalyzerResults;
    getDbmColor: (dbm: number | undefined) => string;
}

@observer
export class NetworkTab extends TechseeBaseComponent<NetworkTabProps> {
    renderInternal() {
        const {results, getDbmColor} = this.props;
        const networksList = results.surroundingNetworks || results.scanAreaResults || [];

        return (
            <div className='wifi-analyzer-content'>
                <div className={'item active'}>
                    <div className='wifi-analyzer-container'>
                        <div className='wifi-analyzer-container-left'>
                            <span className='wifi-analyzer-container-left-ssid'>
                                {results.wifiConnectionInfo ? (
                                    <span>
                                        CH {results.wifiConnectionInfo?.channel}
                                        <span className='gray-badge'>
                                            {results.wifiConnectionInfo?.frequency ?? '2.4 GHz'}
                                        </span>
                                    </span>
                                ) : (
                                    <span>&nbsp;</span>
                                )}

                                <span className='wifi-analyzer-container-left-name'>
                                    {results.wifiConnectionInfo?.ssid || results.name}
                                </span>
                            </span>
                            <span className='wifi-analyzer-container-left-mac'>
                                {results.wifiConnectionInfo?.macAddress}
                            </span>
                        </div>
                        <div className='wifi-analyzer-container-right'>
                            <div className='wifi-analyzer-container-badge'>
                                <Icon iconName={'link'} /> Connected
                            </div>

                            <div className='align-row'>
                                {results.wifiConnectionInfo ? (
                                    <span className={`${getDbmColor(results.wifiConnectionInfo.rssi)} column signal`}>
                                        <Icon style={{fontSize: '20px'}} iconName={'wifi-high'} />
                                        {results.wifiConnectionInfo.signalStrengthPercentage}%
                                    </span>
                                ) : (
                                    <span className='column signal'></span>
                                )}
                                {results.wifiConnectionInfo ? (
                                    <span className={`${getDbmColor(results.wifiConnectionInfo.rssi)} column signal`}>
                                        <span>{results.wifiConnectionInfo.rssi}</span> dBm
                                    </span>
                                ) : (
                                    <span className='column signal'></span>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='wifi-analyzer-container'>
                        <div className='wifi-analyzer-container-column'>
                            <div className='column-items'>
                                <Icon iconName={'lock'} /> Security
                                <span>{results.wifiConnectionInfo?.security || 'N/A'}</span>
                            </div>
                            {results.wifiConnectionInfo?.distanceMeters && (
                                <div className='column-items'>
                                    <Icon iconName={'location'} /> Distance
                                    <span>{results.wifiConnectionInfo.distanceMeters.toFixed(1)}m</span>
                                </div>
                            )}
                        </div>
                        <div className='wifi-analyzer-container-column'>
                            <div className='column-items'>
                                ↑ Upload
                                <span>
                                    {results.networkSpeed?.upSpeedMbps
                                        ? `${results.networkSpeed?.upSpeedMbps} Mbps`
                                        : 'N/A'}
                                </span>
                            </div>
                            <div className='column-items'>
                                ↓ Download
                                <span>
                                    {results.networkSpeed?.downloadSpeedMbps
                                        ? `${results.networkSpeed?.downloadSpeedMbps} Mbps`
                                        : 'N/A'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                {networksList.map((device, idx) => (
                    <div key={idx} className={'item'}>
                        <div className='wifi-analyzer-container'>
                            <div className='wifi-analyzer-container-left'>
                                <span className='wifi-analyzer-container-left-ssid'>
                                    <span>
                                        CH {device.channel}
                                        <span className='gray-badge'>{device.frequency ?? '2.4 GHz'}</span>
                                    </span>

                                    <span className='wifi-analyzer-container-left-name'>{device.ssid}</span>
                                </span>
                                <span className='wifi-analyzer-container-left-mac'>{device.macAddress}</span>
                            </div>
                            <div className='wifi-analyzer-container-right'>
                                <span></span>
                                <div className='align-row'>
                                    <span className={`${getDbmColor(device?.rssi)} column signal`}>
                                        <Icon style={{fontSize: '20px'}} iconName={'wifi-high'} />
                                        {device.signalStrengthPercentage}%
                                    </span>

                                    <span className={`${getDbmColor(device?.rssi)} column signal`}>
                                        <span>{device.rssi}</span> dBm
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className='wifi-analyzer-container'>
                            <div className='wifi-analyzer-container-column align-row'>
                                <div className='column-items'>
                                    <Icon iconName={'lock'} /> Security
                                    <span>{device.security || 'N/A'}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}
